import { Helmet } from "react-helmet-async";

export default function Seo({
  title = "ScrapTrade — Buy & Sell Scrap Online",
  description = "Real-time scrap prices, secure orders, trusted partners across world.",
  url = "https://scraptrade.com.au/",
  image = "https://scraptrade.com.au/assets/og/default.jpg",
  canonical = "https://scraptrade.com.au/",
  extraSchema = null, // per-page schema (About, Contact, etc.)
  breadcrumbs = null // auto JSON-LD for breadcrumbs
}) {
  const breadcrumbSchema = breadcrumbs
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((item, idx) => {
          const fullUrl = item.url?.startsWith("http")
            ? item.url
            : `https://scraptrade.com.au${item.url}`;
          return {
            "@type": "ListItem",
            position: idx + 1,
            name: item.label,
            item: fullUrl
          };
        })
      }
    : null;

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />

      {/* JSON-LD: Website */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "ScrapTrade",
          url: url,
          description: description,
          publisher: {
            "@type": "Organization",
            name: "ScrapTrade",
            logo: {
              "@type": "ImageObject",
              url: image
            }
          }
        })}
      </script>

      {/* JSON-LD: Breadcrumbs */}
      {breadcrumbSchema && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}

      {/* JSON-LD: Extra per-page schema */}
      {extraSchema && (
        <script type="application/ld+json">
          {JSON.stringify(extraSchema)}
        </script>
      )}
    </Helmet>
  );
}
